import React from 'react';
import NationFlag from '../NationFlag';
import {useSelector} from 'react-redux'
import './style.scss';
import {showPlaceHolderorImg} from 'containers/MundialViews/utils/mundialUtils'

export const GroupBracket = ({ groupName, teams }) => {
  const {vcard_team_placeholder_img:placeholderVcard} = useSelector(state=>state.asset)
  return (
    <div className="group-bracket">
      <div className="group-bracket__group-name">
        <span>{groupName}</span>
      </div>
      <div className="group-bracket__teams">
        {teams?.map(team => (
          <NationFlag
            key={team.names.full}
            urlFlag={showPlaceHolderorImg(team.nationality.images.flag,placeholderVcard)}
            nationName={team.names.full}
          />
        ))}
      </div>
    </div>
  );
};
